import React from "react";
import { Box, IconButton, TextField } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { getS3Url } from "utils/common";

const PictureSelectItem = ({
  image,
  label,
  onDelete = () => {},
  onLabelChange = () => {},
  editable = false,
}) => {
  const imageUrl =
    typeof image === "string" ? getS3Url(image) : URL.createObjectURL(image);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 150,
        maxHeight: 150,
        aspectRatio: "1/1",
        borderRadius: 2,
        boxShadow: 1,
        overflow: "hidden",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        transition: "transform 0.2s ease",
        "&:hover": {
          transform: "scale(1.01)",
        },
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: editable ? "calc(100% - 2rem)" : "100%",
          backgroundColor: "#f4f4f4",
        }}
      >
        <img
          src={imageUrl}
          alt="option"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: "block",
          }}
        />

        {editable && (
          <IconButton
            onClick={onDelete}
            sx={{
              position: "absolute",
              top: 6,
              right: 6,
              backgroundColor: "rgba(0,0,0,0.6)",
              color: "#fff",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.8)",
              },
            }}
            size="small"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {/* {!editable && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: "2rem",
            backgroundColor: "rgba(255,255,255,0.8)",
            color: "#000",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="body2">{label}</Typography>
        </Box>
      )} */}

      {editable ? (
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          value={label}
          placeholder="Enter label"
          onChange={(e) => onLabelChange(e.target.value)}
          sx={{
            borderTop: "1px solid #eee",
            "& .MuiInputBase-input": {
              padding: "6px 10px",
              fontSize: "0.875rem",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            height: "2rem",
          }}
        />
      ) : null}
    </Box>
  );
};

export default PictureSelectItem;
